import React, { useState } from "react";

interface BrandLogoProps {
  logoUrl?: string | null;
  name: string;
}

export const BrandLogo: React.FC<BrandLogoProps> = ({ logoUrl, name }) => {
  const [hasError, setHasError] = useState(false);

  if (logoUrl && !hasError) {
    return (
      <div className="w-10 h-10 rounded-xl overflow-hidden bg-slate-50 border border-slate-200/80 shrink-0 flex items-center justify-center shadow-xs">
        <img
          src={logoUrl}
          alt={name}
          className="w-full h-full object-cover"
          onError={() => setHasError(true)}
        />
      </div>
    );
  }

  const initial = name?.trim() ? name.trim().charAt(0).toUpperCase() : "B";
  return (
    <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#FAF5FF] to-[#F3E8FF] border border-[#A655F8]/20 shrink-0 flex items-center justify-center text-[#A655F8] font-bold text-sm shadow-xs select-none">
      {initial}
    </div>
  );
};
